/**
 * Springs inspiration – Web Component
 * Mobile: Swiper slider with peek, arrows and pagination.
 * Desktop: static row, Swiper destroyed.
 */
if (!customElements.get('springs-inspiration-slider')) {
  class SpringsInspirationSlider extends HTMLElement {
    static get BREAKPOINT() {
      return 768;
    }

    constructor() {
      super();
      this.swiper = null;
      this._resizeBound = null;
      this._resizeTimer = null;
      this._swiperRetryTimer = null;
    }

    connectedCallback() {
      this._resizeBound = this._onResize.bind(this);
      this._swiperLoadedBound = this.update.bind(this);
      this.update();
      window.addEventListener('resize', this._resizeBound);
      document.addEventListener('swiper:loaded', this._swiperLoadedBound);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._resizeBound);
      document.removeEventListener('swiper:loaded', this._swiperLoadedBound);
      clearTimeout(this._swiperRetryTimer);
      this._destroySwiper();
    }

    _isMobile() {
      return window.innerWidth < SpringsInspirationSlider.BREAKPOINT;
    }

    update() {
      if (this._isMobile()) {
        this._initSwiper();
      } else {
        this._destroySwiper();
      }
    }

    _getControls() {
      const gallery = this.closest('.springs-inspiration__gallery');
      if (!gallery) return {};

      return {
        prevEl: gallery.querySelector('.springs-inspiration__nav--prev'),
        nextEl: gallery.querySelector('.springs-inspiration__nav--next'),
        paginationEl: gallery.querySelector('.springs-inspiration__pagination')
      };
    }

    _initSwiper() {
      if (this.swiper || !this._isMobile()) return;

      if (!window.Swiper) {
        clearTimeout(this._swiperRetryTimer);
        this._swiperRetryTimer = setTimeout(() => this._initSwiper(), 150);
        return;
      }

      clearTimeout(this._swiperRetryTimer);

      const { prevEl, nextEl, paginationEl } = this._getControls();
      const slideCount = this.querySelectorAll('.swiper-slide').length;

      this.swiper = new window.Swiper(this, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        centeredSlides: false,
        loop: slideCount > 1,
        speed: 500,
        threshold: 6,
        navigation: prevEl && nextEl ? { prevEl, nextEl } : undefined,
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true
            }
          : undefined,
        on: {
          init: () => this.classList.add('springs-inspiration__slider--active'),
          destroy: () => this.classList.remove('springs-inspiration__slider--active')
        }
      });
    }

    _destroySwiper() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
      this.classList.remove('springs-inspiration__slider--active');
    }

    _onResize() {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this.update(), 150);
    }
  }

  customElements.define('springs-inspiration-slider', SpringsInspirationSlider);
}
